import { useEffect, useRef } from 'react'
import { NavLink, useLocation } from 'react-router-dom'

/**
 * §3: module sub-navigation. Active is solid teal, inactive white with a border.
 *
 * On a phone the pills stay on one line and scroll sideways, rather than wrapping
 * into four rows of buttons above every finance page; the current one is brought
 * into view.
 */
export function PillNav({ items }: { items: { to: string; label: string; end?: boolean }[] }) {
  const ref = useRef<HTMLElement>(null)
  const { pathname } = useLocation()

  useEffect(() => {
    const nav = ref.current
    const active = nav?.querySelector<HTMLElement>('[aria-current="page"]')
    if (nav && active && nav.scrollWidth > nav.clientWidth) {
      nav.scrollLeft = active.offsetLeft - (nav.clientWidth - active.offsetWidth) / 2
    }
  }, [pathname])

  return (
    <nav
      ref={ref}
      className="relative -mx-4 mb-5 flex gap-2 overflow-x-auto px-4 pb-1 sm:mx-0 sm:flex-wrap sm:overflow-visible sm:px-0 sm:pb-0"
    >
      {items.map((item) => (
        <NavLink
          key={item.to}
          to={item.to}
          end={item.end}
          className={({ isActive }) =>
            [
              'shrink-0 whitespace-nowrap rounded-full px-4 py-1.5 text-sm font-medium transition',
              isActive
                ? 'bg-dpl-primary text-white'
                : 'border border-dpl-border bg-dpl-surface text-dpl-text hover:border-dpl-primary/40',
            ].join(' ')
          }
        >
          {item.label}
        </NavLink>
      ))}
    </nav>
  )
}
